import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appFocusInputToSelect]',
})
export class FocusInputToSelectDirective {

  constructor(
    private el: ElementRef<HTMLInputElement>,
  ) { }

  @HostListener('focus') onFocusInput() {
    this.el.nativeElement.select();
  }
}
